/**
 * Escolher a cor de uma categoria vendo a cor, não só o nome ("Índigo" não
 * diz nada sozinho). Botão com a bolinha + nome; abre a paleta de círculos.
 * Serve na agenda e em Configurações > Agenda (a paleta vem de cores.css).
 */

import { useEffect, useRef, useState } from "react";

import "./cores.css";

export default function SeletorDeCor({ valor, cores, onChange, rotulo = "Cor" }) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef(null);
  const atual = cores.find((c) => c.valor === valor);

  useEffect(() => {
    if (!aberto) return undefined;
    const fora = (evento) => { if (ref.current && !ref.current.contains(evento.target)) setAberto(false); };
    const tecla = (evento) => {
      if (evento.key !== "Escape") return;
      // Esc fecha só a paleta, não o painel em volta.
      evento.stopPropagation();
      setAberto(false);
    };
    document.addEventListener("pointerdown", fora);
    window.addEventListener("keydown", tecla, true);
    return () => {
      document.removeEventListener("pointerdown", fora);
      window.removeEventListener("keydown", tecla, true);
    };
  }, [aberto]);

  return (
    <span className="ag-paleta-cores ag-seletor-cor" ref={ref}>
      <button type="button" onClick={() => setAberto((v) => !v)} aria-haspopup="true" aria-expanded={aberto} aria-label={`${rotulo}: ${atual?.rotulo || valor}`}>
        <span className={`ag-bolinha ag-cor-${valor || "nenhuma"}`} aria-hidden="true" />
        <span>{atual?.rotulo || valor}</span>
        <span className="ag-seta" aria-hidden="true">▾</span>
      </button>
      {aberto ? (
        <span className="ag-paleta" role="group" aria-label={rotulo}>
          {cores.map((cor) => (
            <button
              key={cor.valor}
              type="button"
              className={`ag-cor-${cor.valor}`}
              aria-pressed={cor.valor === valor}
              aria-label={cor.rotulo}
              title={cor.rotulo}
              onClick={() => { setAberto(false); if (cor.valor !== valor) onChange(cor.valor); }}
            />
          ))}
        </span>
      ) : null}
    </span>
  );
}
